function Footer() {
    return (
        <div className="footer">
            {/*<a src="https://github.com/samgliu/Odinbook-Client" alt="">
                Github
    </a>*/}
        </div>
    );
}

export default Footer;
